module.exports = __webpack_public_path__ + "greenc.a87a724d.png";